import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f10f50e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article-info-main" }
const _hoisted_2 = { class: "article-info" }
const _hoisted_3 = { class: "article-title-pannel" }
const _hoisted_4 = { class: "article-title" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, "标签：标签系统开发中...", -1))
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { title: "创建于" }
const _hoisted_9 = { title: "最近更新" }
const _hoisted_10 = { class: "article-desc-pannel" }
const _hoisted_11 = { class: "desc" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")

import { onMounted, ref } from "@vue/runtime-core";
import { useStore } from "@/store";
import { computed } from "vue";
import type { Article } from "@/api/article";
import { useRouter } from "vue-router";
import type { PropType } from "vue";
import apis from "@/api/article";
import { message } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  article: {
    type: Object as PropType<Article>,
    default: {}
  }
},
  emits: ["updateList"],
  setup(__props, { emit: emits }) {

const props = __props





const router = useRouter();
const store = useStore();
const isOwner = computed(() => store.state.common.isOwner);

function toArticlePage(articleId?: number) {
  if (articleId || articleId == 0) {
    return `/article?articleId=${articleId}`;
  } else {
    return "javascript:void(0)";
  }
}

function toEditArticlePage(articleId?: number) {
  if (articleId == 0 || articleId) {
    router.push({ name: "Write", params: { articleId: articleId, redirect: "/home" } });
  }
}

function deleteArticle(articleId?: number) {
  if (articleId == 0 || articleId) {
    apis.deleteArticle
      .request<Number>({ id: articleId })
      .then((res) => {
        if (res.code > 0 && res.data && res.data > 0) {
          message.success("删除成功");
          emits("updateList");
        } else {
          message.error("删除失败");
        }
      })
      .catch((error) => {
        message.error("删除失败，" + error);
      });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            target: "_blank",
            href: toArticlePage(__props.article.id)
          }, _toDisplayString(__props.article.title ? __props.article.title : "暂无标题"), 9, _hoisted_5)
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, "创建于：" + _toDisplayString(__props.article.createTime ?? "遥远的过去"), 1),
            _createVNode(_component_a_divider, { type: "vertical" }),
            _createElementVNode("span", _hoisted_9, "最近更新：" + _toDisplayString(__props.article.updateTime ?? "遥远的过去"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(__props.article.description
                ? __props.article.description.substring(0, Math.min(__props.article.description.length, 45)) +
                  (__props.article.description.length > 45 ? "..." : "")
                : "暂无文章内容描述"), 1)
        ]),
        (_unref(isOwner))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_a_button, {
                size: "small",
                type: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toEditArticlePage(__props.article.id)))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                size: "small",
                type: "dashed",
                danger: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteArticle(__props.article.id)))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})